var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDocument(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1065_35550)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6922 4.18281L13.5672 1.05781C13.5091 0.999791 13.4402 0.953782 13.3643 0.922415C13.2884 0.891047 13.2071 0.874936 13.125 0.875H6.875C6.54348 0.875 6.22554 1.0067 5.99112 1.24112C5.7567 1.47554 5.625 1.79348 5.625 2.125V3.375H4.375C4.04348 3.375 3.72554 3.5067 3.49112 3.74112C3.2567 3.97554 3.125 4.29348 3.125 4.625V15.875C3.125 16.2065 3.2567 16.5245 3.49112 16.7589C3.72554 16.9933 4.04348 17.125 4.375 17.125H13.125C13.4565 17.125 13.7745 16.9933 14.0089 16.7589C14.2433 16.5245 14.375 16.2065 14.375 15.875V14.625H15.625C15.9565 14.625 16.2745 14.4933 16.5089 14.2589C16.7433 14.0245 16.875 13.7065 16.875 13.375V4.625C16.8751 4.5429 16.859 4.46159 16.8276 4.38572C16.7962 4.30985 16.7502 4.2409 16.6922 4.18281ZM10.625 14H6.875C6.70924 14 6.55027 13.9342 6.43306 13.8169C6.31585 13.6997 6.25 13.5408 6.25 13.375C6.25 13.2092 6.31585 13.0503 6.43306 12.9331C6.55027 12.8158 6.70924 12.75 6.875 12.75H10.625C10.7908 12.75 10.9497 12.8158 11.0669 12.9331C11.1842 13.0503 11.25 13.2092 11.25 13.375C11.25 13.5408 11.1842 13.6997 11.0669 13.8169C10.9497 13.9342 10.7908 14 10.625 14ZM10.625 11.5H6.875C6.70924 11.5 6.55027 11.4342 6.43306 11.3169C6.31585 11.1997 6.25 11.0408 6.25 10.875C6.25 10.7092 6.31585 10.5503 6.43306 10.4331C6.55027 10.3158 6.70924 10.25 6.875 10.25H10.625C10.7908 10.25 10.9497 10.3158 11.0669 10.4331C11.1842 10.5503 11.25 10.7092 11.25 10.875C11.25 11.0408 11.1842 11.1997 11.0669 11.3169C10.9497 11.4342 10.7908 11.5 10.625 11.5ZM15.625 13.375H14.375V7.125C14.3751 7.0429 14.359 6.96159 14.3276 6.88572C14.2962 6.80985 14.2502 6.7409 14.1922 6.68281L11.0672 3.55781C11.0091 3.49979 10.9402 3.45378 10.8643 3.42241C10.7884 3.39105 10.7071 3.37494 10.625 3.375H6.875V2.125H12.8664L15.625 4.88359V13.375Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1065_35550",
    x: -0.875,
    y: 0.875,
    width: 21.75,
    height: 24.25,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1065_35550"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1065_35550",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDocument);
export default __webpack_public_path__ + "static/media/icon_document.2b55e79f1e9bd4aeb16e40782969b533.svg";
export { ForwardRef as ReactComponent };